import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild} from '@angular/core';
import {ModelService} from '@service/model/model.service';
import {DexiedbService} from '@service/dexiedb/dexiedb.service';
import {SearchService} from '@service/search/search.service';
import {takeUntil} from 'rxjs/operators';
import {MediaMatcher} from '@angular/cdk/layout';
import {Subject} from 'rxjs';
import {AuthService} from '@service/auth/auth.service';

@Component({
    selector: 'app-search-sidenav',
    templateUrl: './search-sidenav.component.html',
    styleUrls: ['./search-sidenav.component.scss'],
    standalone: false
})
export class SearchSidenavComponent implements AfterViewInit, OnDestroy {
  @ViewChild('sidenavFilter', {static: false}) filter: any;
  private destroy$ = new Subject();
  public isSearching = false;
  startLoadingSearch: boolean;
  mobileQuery?: MediaQueryList;
  private _mobileQueryListener = () => {};

  constructor(private modelService: ModelService, private db: DexiedbService, private searchService: SearchService,
              private cdr: ChangeDetectorRef, private media: MediaMatcher, private authService: AuthService) {
    this.startLoadingSearch = this.modelService.areThereAnyPreviousFilter();
    this.setupMediaQueryListener();
  }

  ngAfterViewInit(): void {
    this.checkToOpenSearchFilter();
  }

  ngOnDestroy(): void {
    this.mobileQuery?.removeEventListener('change', this._mobileQueryListener);
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  private checkToOpenSearchFilter(): void {
    if (this.modelService.areThereAnyPreviousFilter()) {
      this.openMenu(this.modelService.lastFilters);
      this.cdr.detectChanges();
    } else {
      this.db.isFilterPinned().then(isPinned => {
        if (isPinned) {
          this.openMenu();
        }
      });
    }
  }

  private setupMediaQueryListener(): void {
    this.searchService.filtersData.pipe(takeUntil(this.destroy$)).subscribe(({filters}) => {
      if (this.isSearchMenuFullWidth && filters) {
        this.filter?.close();
      }
    });
    this.mobileQuery = this.media.matchMedia('not (min-width: 768px)');
    this._mobileQueryListener = () => {
      if (!this.isSearchMenuFullWidth && this.isSearching) {
        this.filter?.open();
      }
      this.cdr.detectChanges();
    };
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  get isSearchMenuFullWidth(): boolean {
    const matSidenavElement = document.querySelector('mat-sidenav.fixed-filter-width');
    return matSidenavElement && matSidenavElement.parentElement ?
      window.getComputedStyle(matSidenavElement).width === window.getComputedStyle(matSidenavElement.parentElement).width :
      false;
  }

  public closeMenu(): void {
    this.filter.close();
    this.isSearching = false;
    this.searchService.filters.next({filters: null});
  }

  public openMenu(lastFilter: any = null): void {
    this.filter.open();
    this.isSearching = true;
    this.searchService.filters.next({filters: lastFilter});
  }

  canGoToCRM(): boolean {
    return this.authService.crmInstalled && this.authService.currentUserPermission.crmSectionsVisible.length > 0;
  }
}
